import { createModule } from '../actions/utils';
import { SERVICE_ENDPOINT } from '../apis/constants';

const GetAnnualMaintenanceContractWorkflows = createModule(
  { base: 'GET_ANNUAL_MAINTENANCE_CONTRACT_WORKFLOWS', apiDetails: SERVICE_ENDPOINT.WORKFLOWS },
);

export { GetAnnualMaintenanceContractWorkflows };
